<template>
  <VView class="contest-error" :back-button-to="backButtonTo" :header="$t('contestError.header')">
    <VText center>{{ $t('contestError.content.0') }}</VText>
    <VText center small>{{ $t('contestError.content.1') }}</VText>
  </VView>
</template>

<script>
export default {
  name: 'ContestEnd',

  props: {
    backButtonTo: {
      type: String,
      default: '/menu',
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-end {}
</style>
